import { render } from "./ForgotPassword.Recovery.vue?vue&type=template&id=a5c7c034"
import script from "./ForgotPassword.Recovery.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.Recovery.vue?vue&type=script&lang=js"

import "./ForgotPassword.Recovery.vue?vue&type=style&index=0&id=a5c7c034&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__